var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 88",
    style: {
      enableBackground: "new 0 0 88 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A0DFDA;}\r\n\t.st1{fill:none;stroke:#030000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.6,6.4l6.7,76.1l30.4-0.7l5.9-74.8L22.6,6.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56,85.7c1.4-8,2.6-26.3,0.5-39.9c-1.5-10.3-0.1-16.7,0.9-26.7c1.7,4.3,3.1,8.6,4.3,13.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.1,56.6c-1.2,9.4-1.7,18.7-2.8,28.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.3,57c1-0.1,2.7-1.2,3.3-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.5,45.8c-7.1,2.1-15.2,1.5-22.5,0.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.3,57c0.1,3,1.6,24.4,1.7,27.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.6,1c0,2.7-1.6,4.8-3.9,5.9s-4.8,1.4-7.2,2.3c-1.8,0.6-3.1,1.9-4.2,3.4C24,17.3,22.7,23,21.5,28.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.6,22.3c-3.4,0.7-7,0.1-9.9-1.8c-0.6-0.4-1.3-1-1.4-1.7C30.2,18,31,17.1,31.8,18s3.1,14,2.6,21.2 c-0.2,3-0.6,6.1-0.9,9.1c-1.4,12.9-0.9,25.9,1.3,38.7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.1,21c-1.4,1.9-4.7,2-7.8,1.6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.7,21.9c-1.5,4-3.1,7.9-4.8,11.7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.6,1.4c0.7,1.6,1.5,3.2,2.9,4.3c2.1,1.7,5,1.7,7.2,3.1c2.2,1.4,3.3,4,4.3,6.4c1.5,3.7,2.9,7.5,4.2,11.3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.8,23.3c1.4,1.2,3.1,2.2,4.8,2.9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.2,23.9c-1.3,0.9-2.7,1.6-4.2,2.2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.9,7.5c0.5,0.6,1.3,1.1,2,1.5c1.5,0.7,3.2,1,4.8,0.6c1.6-0.4,3.1-1.4,3.8-2.9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.9,76.4c2.7,0.5,5.5,0.7,8.2,0.7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.6,77.1c2.6-0.1,5.2-0.3,7.8-0.8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcto);
export default __webpack_public_path__ + "static/media/ecto.7edcfc29b7dba720e3debdccaf8057f8.svg";
export { ForwardRef as ReactComponent };